import constants from "constants";

const {
  MODAL_TYPE_DELETE_CONFIRMATION,
  MODAL_DELETE_CONFIRMATION_TYPE,
  SHOW_MODAL,
  MODAL_TYPE_USER_LEAVE_GROUP,
  MODAL_ADD_TO_CALENDAR,
} = constants;

const showModal = (modalType, modalContentProps = {}) => ({
  type: SHOW_MODAL,
  modalType,
  modalContentProps,
});

export const showDeleteWebinarsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.webinar,
  });
};

export const showDeleteGroupWebinarsConfirmationModal = (ids, query) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    query,
    type: MODAL_DELETE_CONFIRMATION_TYPE.groupWebinar,
  });
};

export const showDeleteBookingsConfirmationModal = (ids, query) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    query,
    type: MODAL_DELETE_CONFIRMATION_TYPE.booking,
  });
};

export const showDeleteSponsorsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.sponsor,
  });
};
export const showDeleteDisciplinesConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.discipline,
  });
};

export const showDeletePartnersConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.partner,
  });
};

export const showDeleteUsersConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.user,
  });
};

export const showDeleteClientUrlsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.clientUrls,
  });
};

export const showDeleteSuperhostsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.superhost,
  });
};

export const showDeleteStudygroupsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.studygroups,
  });
};

export const showDeleteCourseMaterialsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.courseMaterials,
  });
};

export const showDeleteGroupMemberConfirmationModal = (payload) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    payload,
    type: MODAL_DELETE_CONFIRMATION_TYPE.groupMember,
  });
};

export const showDeleteGroupInviteConfirmationModal = (payload) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    payload,
    type: MODAL_DELETE_CONFIRMATION_TYPE.groupInvite,
  });
};

export const showUserLeaveGroupModal = (payload) => {
  return showModal(MODAL_TYPE_USER_LEAVE_GROUP, {
    payload,
    type: MODAL_DELETE_CONFIRMATION_TYPE.groupInvite,
  });
};

export const showAddToCalendarModal = (payload) => {
  return showModal(MODAL_ADD_TO_CALENDAR, {
    payload,
  });
};



// WEBPACK FOOTER //
// ./src/actions/mixed.js